// Plantilla de documento (membrete Gerencia TI) para exportaciones PDF.
// Encabezado: logo ZAE + "GERENCIA TI" + título; línea divisora roja.
// Pie: onda decorativa roja intensa.
import { LOGO_DATA_URL, LOGO_W, LOGO_H } from "./logoData";

export const BRAND_RED = [227, 30, 36]; // #E31E24 rojo intenso
export const BRAND_RED_LIGHT = [247, 168, 163];
export const BRAND_RED_HEX = "FFE31E24";

const dateEsMX = (d = new Date()) =>
  d.toLocaleDateString("es-MX", { day: "2-digit", month: "long", year: "numeric" });

// Dibuja una onda rellena desde baseY hacia el borde inferior de la página.
function fillWave(doc, baseY, amp, phase, color) {
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  const step = 3;
  const pts = [];
  for (let x = 0; x <= W; x += step) {
    const y = baseY + amp * Math.sin((x / W) * Math.PI * 3 + phase);
    pts.push([x, y]);
  }
  if (pts[pts.length - 1][0] < W) pts.push([W, baseY + amp * Math.sin(Math.PI * 3 + phase)]);
  const rel = [];
  for (let i = 1; i < pts.length; i++) rel.push([pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]]);
  rel.push([0, H - pts[pts.length - 1][1]]);
  rel.push([-(pts[pts.length - 1][0]), 0]);
  doc.setFillColor(color[0], color[1], color[2]);
  doc.lines(rel, pts[0][0], pts[0][1], [1, 1], "F", true);
}

// Pie de página con onda roja (rim claro, banda blanca, base roja intensa).
export function drawFooterWave(doc) {
  const H = doc.internal.pageSize.getHeight();
  const band = Math.min(64, H * 0.12);
  const base = H - band;
  const amp = Math.min(15, band * 0.28);
  fillWave(doc, base - amp * 1.1, amp, 0.8, BRAND_RED_LIGHT);
  fillWave(doc, base + amp * 0.15, amp, 0.4, [255, 255, 255]);
  fillWave(doc, base + amp * 1.0, amp, 0.0, BRAND_RED);
}

// Encabezado con logo + "GERENCIA TI" + título. Devuelve la Y donde inicia el contenido.
export function drawLetterhead(doc, { title = "", dateStr } = {}) {
  const W = doc.internal.pageSize.getWidth();
  const margin = 40;
  // Logo (mantiene proporción)
  const logoH = 38;
  const logoW = logoH * (LOGO_W / LOGO_H);
  const logoY = 24;
  try {
    doc.addImage(LOGO_DATA_URL, "PNG", margin, logoY, logoW, logoH);
  } catch (e) { /* ignore */ }

  const textX = margin + logoW + 14;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.setTextColor(BRAND_RED[0], BRAND_RED[1], BRAND_RED[2]);
  doc.text("Dirección de TI", textX, 40);

  doc.setFont("helvetica", "italic");
  doc.setFontSize(7.5);
  doc.setTextColor(120, 130, 145);
  doc.text("Comprometidos con la innovación, la eficiencia y el crecimiento.", textX, 52);

  // Fecha y título del documento a la derecha
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(100, 116, 139);
  doc.text(dateStr || dateEsMX(), W - margin, 40, { align: "right" });
  if (title) {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(9.5);
    doc.setTextColor(51, 65, 85);
    doc.text(title, W - margin, 54, { align: "right" });
  }

  // Línea divisora roja
  const lineY = 72;
  doc.setDrawColor(BRAND_RED[0], BRAND_RED[1], BRAND_RED[2]);
  doc.setLineWidth(1.6);
  doc.line(margin, lineY, W - margin, lineY);
  // acento fino gris debajo
  doc.setDrawColor(203, 213, 225);
  doc.setLineWidth(0.4);
  doc.line(margin, lineY + 2.4, W - margin, lineY + 2.4);

  doc.setTextColor(0, 0, 0);
  return lineY + 16; // contentTop
}

export function contentBottom(doc) {
  const H = doc.internal.pageSize.getHeight();
  return H - Math.min(64, H * 0.12) - 6;
}
